// TODO: place here mock photo in base64 format as string
export default {};
